module.exports = __webpack_public_path__ + "static/media/logo-02.5c958ba8.svg";